// custom-legend.tsx
import { memo } from 'react';

export interface LegendItem {
  key: string;
  label: string;
  color: string;
  visible: boolean;
}

export interface CustomLegendProps {
  items: LegendItem[];
  onToggle: (key: string) => void;
}

function CustomLegendImpl({ items, onToggle }: Readonly<CustomLegendProps>) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '8px 12px',
        justifyContent: 'center',
        backgroundColor: '#f3f3f5',
        border: '1px solid #F0F1F3',
        borderRadius: 8,
        padding: '10px 12px',
        marginTop: 4,
        marginBottom: 20,
      }}
    >
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={() => onToggle(item.key)}
          title={item.label}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '2px 4px',
            maxWidth: '180px',
            opacity: item.visible ? 1 : 0.4,
          }}
        >
          <span
            style={{
              width: 12,
              height: 12,
              borderRadius: '50%',
              backgroundColor: item.color,
              flexShrink: 0,
            }}
          />
          <span
            style={{
              fontSize: 14,
              color: item.visible ? '#374151' : '#9CA3AF',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
            }}
          >
            {item.label}
          </span>
        </button>
      ))}
    </div>
  );
}

export default memo(CustomLegendImpl);
